// MM/DD/YYYY, M/D/YYYY
const DATE_REGEX = new RegExp(/^(\d{2}|\d{1})\/(\d{2}|\d{1})\/\d{4}$/);
const DATE_REGEX_DASH = new RegExp(/^(\d{2}|\d{1})-(\d{2}|\d{1})-\d{4}$/);

export { DATE_REGEX };
export { DATE_REGEX_DASH };
